import React from 'react';
import formFieldType from '@/forms/helper';
import FormObjectDialog from '@/forms/objects/components/FormObjectDialog';
import selectors from '../hooks/selectors';
import events from '../hooks/events';
import catalogueFieldComponents from '../helper';

const CatalogueObjectDialog = ({ theme }) => {
  const state = selectors.useCatalogueObjectFields();
  const applyChanges = events.useApplyCatalogueObjects(state.category, { code: state.code });
  const changeItem = events.useUpdateActiveCatalogueObject();
  const deleteItem = events.useDeleteActiveCatalogueObject();
  const hide = events.useHideCatalogueObjects();
  const insertItem = events.useInsertCatalogueObject();
  const updateProperties = events.useUpdateCatalogueObjectProperties();
  const updateObjectsProperties = events.useUpdateCatalogueObjectsProperties();
  const showEdit = events.useEditCatalogueObjects();

  return (
    <FormObjectDialog
      activeIndex={state.activeIndex}
      allowAdd={state.allowAdd}
      allowRemove={state.allowRemove}
      canEdit={state.canEdit}
      category={state.category}
      changeItem={changeItem}
      code={state.code}
      component={(f) => catalogueFieldComponents[formFieldType(f)]}
      deleteItem={deleteItem}
      entity="catalogue.object"
      field={state.field}
      fields={state.field?.fields || []}
      hide={hide}
      insertItem={() => insertItem(state)}
      isDirty={state.isDirty}
      isEditing={state.isEditing}
      item={state.item}
      items={state.items}
      onSave={() => applyChanges(state)}
      saveErrors={state.saveErrors}
      saveStatus={state.saveStatus}
      showEdit={() => showEdit(state)}
      textField={state.textField}
      theme={theme}
      updateObjectsProperties={updateObjectsProperties}
      updateProperties={(attributes) => updateProperties({ ...attributes, template: state.template })}
    />
  );
};

export default CatalogueObjectDialog;
